// import {deleteSysDownloadApi, listSysDownloadApi} from '../../api/sysDownloadApi';
const deleteSysDownloadApi = () => {};
const listSysDownloadApi = () => {}
export default {
  data () {
    return {
      listDownloadApi: listSysDownloadApi,
      deleteDownloadApi: deleteSysDownloadApi,
      downloadParams: {}
    };
  },
  methods: {
    viewExportData () {
      this.getDownloadDialog().show();
    },
    getDownloadDialog() {
      return this.$refs.downloadDialog;
    },
    setDownloadParams (downloadParams) {
      this.downloadParams = downloadParams;
    }
  }
};
